<template>
<el-card class="address-card" shadow="always">
  <div class="address-card__title">
   <custom-inner-marker-icon class="address-card__title__icon" :inner-icon="titleIcon"/>
    <span class="bold address-card__title__label">{{ title }}</span>
  </div>
  <div class="address-card__body">
    <div class="address-card__section address-card__section--address">
      <span class="bold address-card__section__title address-card__section--address__title">
          {{$t('validate.usefulInfo')}}
      </span>
      <div class="address-card__section__content">
        <div class="address-card__section__content__line">
          <div class="address-card__section__content__line__icon">
            <font-awesome-icon :icon="['fal', 'map-marker-alt']"
                               class="next-icon" />
          </div>
          <div class="address-card__section__content__line__info">
            <span class="address-card__section__content__line__info__title">
              {{$t('validate.address')}}
            </span>
            <span>{{ addressText }}</span>
          </div>
        </div>
        <div  class="address-card__section__content__line">
          <div class="address-card__section__content__line__icon">
            <font-awesome-icon :icon="['fal', 'calendar']"
                               class="next-icon"
            />
          </div>
          <div class="address-card__section__content__line__info">
            <span class="address-card__section__content__line__info__title">
              {{$t('validate.date')}}
            </span>
            <span>{{ date }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="address-card__section">
      <maps class="address-card__section__map"
            :markers="address"></maps>
    </div>
    <div class="address-card__section">
      <next-table title="Accès"
        :items="accessInfo"
        :isEmpty="!displayAccess"
        :emptyText="$t('validate.unknownAccess')" />
    </div>
  </div>
</el-card>
</template>

<script>
import Maps from '../utils/Maps.vue';
import CustomInnerMarkerIcon from './CustomeInnerMakerIcon.vue';
import NextTable from '@/components/validate/NextTable.vue';
import { isUnknownStreet } from '@/store/utils';

export default {
  name: 'AddressCard',
  components: { NextTable, CustomInnerMarkerIcon, Maps },
  props: {
    address: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    housingType: {
      type: String,
      required: true,
    },
    floor: {
      type: String,
      required: true,
    },
    lift: {
      type: Boolean,
    },
    liftComment: {
      type: String,
    },
    portage: {
      type: String,
    },
    vl: {
      type: Boolean,
    },
    date: {
      type: String,
      required: true,
    },
    titleIcon: {
      type: Array,
      default() {
        return ['fal', 'truck'];
      },
    },
    displayAccess: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    housingText() {
      let floor = '';
      if (this.floor) {
        floor = ` / ${this.$t('validate.floor')} : ${this.floor}`;
      }
      return `${this.housingType}${floor}`;
    },
    liftText() {
      return this.lift ? `${this.$t('validate.lift')} : ${this.$t('base.yes')} - ${this.liftComment}`
        : `${this.$t('validate.lift')} : ${this.$t('base.no')}`;
    },
    portageText() {
      return `Portage : ${this.portage}`;
    },
    vlText() {
      const variable = !this.vl ? `${this.$t('validate.vl.canPark')}`
        : `${this.$t('validate.vl.cannotPark')}`;
      return `${this.$t('validate.vl.access')} : ${variable}`;
    },
    addressText() {
      const { address } = this.address[0];
      if (isUnknownStreet(this.address[0])) {
        return `${this.$t('validate.unknownAddress')}, ${address.postal} ${address.city}`;
      }
      return `${address.street}, ${address.postal} ${address.city}`;
    },
    accessInfo() {
      return [
        this.housingText,
        this.liftText,
        this.portageText,
        this.vlText,
      ];
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep{
    .el-table_1_column_1.address-card__section--access__title.is-leaf {
      color: $--color-secondary;
      display: block;
      background-color: rgba(55,55,55,0.2) !important;
      width: 100%;
      height: 32px;
    }
  }

  .next-icon{
    width: 32px;
    height: 32px;
  }
  .address-card {
    &__title{
      text-transform: uppercase;
      font-size: $--font-size-large;
      display: flex;
      margin-bottom: 8px;
      align-items: center;
      &__icon{
      }
      &__label{
        padding-left: 8px;
      }
    }
    &__body{
      width: 100%;
      display: flex;
      flex-direction: column;
      @include breakpoint(desktop){
        flex-direction: row;
      }
    }
    &__section {
      position: relative;
      flex: 1 0;
      margin: 8px;
      border-radius: 4px;
      &__title{
        font-size: 17px;
        min-height: 32px;
        border-radius: 4px 4px 0 0;
      }
      &--address{
        background-color: rgba(28, 219, 161, 0.1);
        padding: 0 !important;
        &__title{
          display: flex;
          align-items: center;
          background-color: rgba(28, 219, 161, 0.3);
          width: 100%;
          padding: 10px;
        }
      }
      &__content{
        display: block;
        margin: .8em;
        &__line{
          display: grid;
          grid-template-columns: 50px auto;
          justify-content: start;
          align-content: center;
          align-items: center;
          margin: 10px 0;

          &__icon {
            box-shadow: 0 2px 3px 2px rgba(0,0,0, 0.1);
            display: grid;
            place-items: center;
            background-color: white;
            color: $--color-primary;
            height: 48px;
            width: 48px;
            border-radius: $--border-radius-circle;
            svg {
              margin: auto;
            }
          }
          &__info {
            padding-left: 16px;
            display: flex;
            flex-direction: column;
            font-size: $--font-size-small;
            &__title{
              font-weight: $--font-weight-500;
              font-size: $--font-size-medium;
            }
          }
        }
      }
    }
  }
</style>
